
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bY5Ny", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8b69cbb362a344ed$export$6503ec6e8aabbaf; }, function (v) { return $8b69cbb362a344ed$export$6503ec6e8aabbaf = v; });
var $8b69cbb362a344ed$export$6503ec6e8aabbaf;
var $8b69cbb362a344ed$export$f7ad0328861e2f03;
"use strict";
var $8b69cbb362a344ed$var$mapping = new Map();
function $8b69cbb362a344ed$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$8b69cbb362a344ed$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $8b69cbb362a344ed$var$resolve(id) {
    var resolved = $8b69cbb362a344ed$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$8b69cbb362a344ed$export$6503ec6e8aabbaf = $8b69cbb362a344ed$var$register;
$8b69cbb362a344ed$export$f7ad0328861e2f03 = $8b69cbb362a344ed$var$resolve;

});

var $a3d58f985a6ef8be$exports = {};

(parcelRequire("bY5Ny")).register(new URL("", import.meta.url).toString(), JSON.parse('["dwTn7","index.471d7eb1.js","lrCb8","alku-logo.a90db96a.png","ikaNE","logo.a6de682e.png"]'));


//# sourceMappingURL=index.runtime.9e620c77.js.map
